import { put } from "redux-saga/effects";
import axios from "../../utils/axios";
import handle from "./handle";
import { GET_ALL_DATA, INIT_ALL_DATA, REQ_ALL_DATA, INIT_REQ_ALL_DATA } from "../../store/allDataStore/actionType";
import { GLOBAL_STORE } from "../../store/globalStore/actionType";
import { GET_RECORD_DATA, REQ_RECORD_DATA } from "../../store/recordDataStore/actionType";

const api = {
  //获取全部数据列表的数据
  getAllData: function * ({ params }) {
    if (params.page === 1) {
      yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    } else {
      yield put ({ type: GLOBAL_STORE, store: { loading: true } });
    }
    const res = yield axios ("/shop/index/list", { ...params }, false, "GET");
    if (res && res.data) {
      const allData = {
        data: [...res.data.list],
        page: res.data["current_page"],
        onBottom: res.data["current_page"] >= res.data["total_page"]
      };
      if (params.page === 1) {//初始化
        yield put ({ type: INIT_ALL_DATA, allData });
        yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
      } else {
        yield put ({ type: GET_ALL_DATA, allData });
        yield put ({ type: GLOBAL_STORE, store: { loading: false } });
      }
    }
  },
  //获取数据
  getRecordData: function * ({ params }) {
    const { dict_id, sid, startDate, endDate } = params;
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    const res = yield axios ("/shop/index/data", { start_date: startDate, end_date: endDate, dice_id: dict_id, sid });
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
    if (res && res.data) {
      const { info, showData } = yield handle.handleRecordData (res, startDate, endDate, dict_id);
      yield put ({ type: GET_RECORD_DATA, recordData: { info, showData } });
    }
  },
  //删除全部列表数据
  deleteData: function (params) {
    return axios (`/shop/index/del?sid=${params.sid}`, { ...params }, false, "POST");
  },
  //添加数据
  sendRecordData: (params) => {
    return axios (`/shop/index/add?sid=${params.sid}`, { ...params }, false, "POST");
  },
  //获取生日和性别
  getBirthdayAndSexual: (params) => {
    return axios ("/shop/index/info", { ...params }, false, "GET");
  },
  sentBirthdayAndSexual: (params) => {
    return axios (`/userapi/user/auth/info?sid=${params.sid}`, { ...params }, false, "PUT");
  },
  getUserInfo: (params) => {
    return axios (`/userapi/user/auth/detail?sid=${params.sid}`);
  },
};

export { REQ_ALL_DATA, INIT_REQ_ALL_DATA, REQ_RECORD_DATA };
export default api;



